import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { AlertTriangle, Wrench, X, ArrowRight } from "lucide-react";

const KEY = "ci_status_banner_dismissed";

export function StatusBanner() {
  const [issues, setIssues] = useState([]);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    api.get("/status").then((r) => {
      const bad = r.data.filter((s) => s.status !== "online");
      setIssues(bad);
      const sig = bad.map((s) => `${s.id}:${s.status}:${s.updated_at}`).join("|");
      setHidden(sessionStorage.getItem(KEY) === sig);
    }).catch(() => {});
  }, []);

  if (!issues.length || hidden) return null;
  const critical = issues.some((s) => s.status === "instability");
  const sig = issues.map((s) => `${s.id}:${s.status}:${s.updated_at}`).join("|");
  const dismiss = () => { sessionStorage.setItem(KEY, sig); setHidden(true); };
  const names = issues.map((s) => s.name).join(", ");
  const Icon = critical ? AlertTriangle : Wrench;
  const tone = critical
    ? "bg-red-500/15 border-red-500/30 text-red-200"
    : "bg-amber-400/15 border-amber-400/30 text-amber-100";

  return (
    <div data-testid="status-banner" data-severity={critical ? "instability" : "maintenance"}
      className={`border-b ${tone} backdrop-blur-sm`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-2.5 flex items-center gap-3 text-sm">
        <Icon className={`w-4 h-4 shrink-0 ${critical ? "text-red-300 animate-pulse" : "text-amber-300"}`} />
        <p className="flex-1 min-w-0 truncate" data-testid="status-banner-text">
          <span className="font-semibold">{critical ? "Instabilidade" : "Manutenção"}:</span> {names}
          {issues.length === 1 && issues[0].message && <span className="opacity-80"> — {issues[0].message}</span>}
        </p>
        <Link to="/status" data-testid="status-banner-link" className="hidden sm:inline-flex items-center gap-1 font-semibold hover:underline shrink-0">
          Ver status <ArrowRight className="w-3.5 h-3.5" />
        </Link>
        <button onClick={dismiss} data-testid="status-banner-close" aria-label="Fechar aviso" className="p-1 rounded-md hover:bg-white/10 shrink-0">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
